<div class="flex min-h-full flex-col bg-[#F8FCF9]">
  <!-- Page routée : safe-area WebView ; en usage inline le conteneur parent la gère déjà -->
  @if (autoNavigate) {
    <vw-header-padding-safe-area [look]="'white'"></vw-header-padding-safe-area>
  }
  <!-- Header -->
  <div class="flex items-center gap-3 px-4 pt-4">
    <button type="button" class="text-2xl leading-none text-[#023E42]" (click)="back()">&#8592;</button>
    <div>
      @if (presetZoneName) {
        <p class="text-xs text-[#9BA6A1]">{{ 'garden.beds.create.zone' | translate }} « {{ presetZoneName }} »</p>
      }
      <h1 class="text-2xl font-bold text-[#023E42]">
        {{ (isRectangular ? 'garden.beds.create.title-rect' : 'garden.beds.create.title-pot') | translate }}
      </h1>
    </div>
  </div>

  <div class="flex flex-col gap-5 px-4 pb-32 pt-4">
    <!-- Type (chip + Changer) -->
    <div class="flex items-center gap-3 rounded-xl border p-3"
      [class.border-primary-300]="true" [class.bg-primary-50]="isRectangular">
      <span class="flex h-10 w-10 items-center justify-center rounded-lg bg-white text-lg">
        {{ isRectangular ? '🔲' : '🪴' }}
      </span>
      <span class="flex-1">
        <span class="block text-sm font-semibold text-[#023E42]">{{ 'garden.beds.type.' + type | translate }}</span>
        <span class="block text-xs text-[#9BA6A1]">{{ 'garden.beds.type.' + type + '-hint' | translate }}</span>
      </span>
      <button type="button" class="text-sm font-medium text-primary-600"
        (click)="selectType(isRectangular ? GardenBedType.POT : GardenBedType.RECTANGULAR)">
        {{ 'garden.beds.create.change-type' | translate }}
      </button>
    </div>

    <!-- Zone (dropdown si non imposée) -->
    @if (!presetZoneName) {
      <div class="flex flex-col gap-1">
        <label class="text-sm text-[#9BA6A1]">{{ 'garden.beds.create.zone' | translate }}</label>
        <vw-dropdown [options]="zones" [placeholder]="'garden.beds.create.zone-placeholder' | translate" [(ngModel)]="zone"></vw-dropdown>
      </div>
    }

    <!-- Name -->
    <div class="flex flex-col gap-1">
      <label class="text-sm text-[#9BA6A1]">{{ (isRectangular ? 'garden.beds.create.name' : 'garden.beds.create.name-pot') | translate }} *</label>
      <vw-text-input type="text" [placeholder]="'garden.beds.create.name-placeholder' | translate" [(ngModel)]="name" [isError]="nameError"></vw-text-input>
    </div>

    <!-- Géométrie -->
    <div class="rounded-xl bg-white p-4">
      @if (isRectangular) {
        <div class="mb-3 flex items-baseline justify-between">
          <h2 class="text-base font-semibold text-[#023E42]">{{ 'garden.beds.create.dimensions' | translate }}</h2>
          <span class="text-xs text-[#9BA6A1]">{{ 'garden.beds.create.one-cell' | translate }}</span>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="text-sm text-[#9BA6A1]">{{ 'garden.beds.create.rows' | translate }}</label>
            <div class="mt-1 flex items-center justify-between rounded-lg border border-gray-200">
              <button type="button" class="px-4 py-2 text-lg text-[#023E42]" (click)="step('rows', -1)">−</button>
              <span class="text-base font-semibold text-[#023E42]">{{ rows }}</span>
              <button type="button" class="px-4 py-2 text-lg text-[#023E42]" (click)="step('rows', 1)">+</button>
            </div>
          </div>
          <div>
            <label class="text-sm text-[#9BA6A1]">{{ 'garden.beds.create.columns' | translate }}</label>
            <div class="mt-1 flex items-center justify-between rounded-lg border border-gray-200">
              <button type="button" class="px-4 py-2 text-lg text-[#023E42]" (click)="step('columns', -1)">−</button>
              <span class="text-base font-semibold text-[#023E42]">{{ columns }}</span>
              <button type="button" class="px-4 py-2 text-lg text-[#023E42]" (click)="step('columns', 1)">+</button>
            </div>
          </div>
        </div>

        <!-- Aperçu grille -->
        <div class="mt-4 rounded-lg bg-[#F8FCF9] p-3">
          <div class="mb-2 flex items-baseline justify-between">
            <span class="text-sm text-[#6B7472]">{{ 'garden.beds.create.preview' | translate }}</span>
            <span class="text-xs text-[#9BA6A1]">{{ 'garden.beds.create.cells-count' | translate: { count: gridCellCount } }}</span>
          </div>
          <div class="grid gap-1.5" [style.grid-template-columns]="'repeat(' + columns + ', minmax(0, 1fr))'">
            @for (c of previewCells; track $index) {
              <div class="aspect-square rounded border border-dashed border-primary-300"></div>
            }
          </div>
          <p class="mt-2 text-center text-xs text-[#9BA6A1]">{{ 'garden.beds.create.grid-hint' | translate }}</p>
        </div>
      } @else {
        <h2 class="mb-1 text-base font-semibold text-[#023E42]">{{ 'garden.beds.create.capacity-title' | translate }}</h2>
        <div class="mt-2 flex items-center justify-between">
          <div class="pr-3">
            <p class="text-base font-semibold text-[#023E42]">{{ 'garden.beds.create.capacity' | translate }}</p>
            <p class="text-xs text-[#9BA6A1]">{{ 'garden.beds.create.capacity-hint' | translate }}</p>
          </div>
          <div class="flex items-center gap-3">
            <button type="button" class="flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 text-lg" (click)="step('capacity', -1)">−</button>
            <span class="text-xl font-bold text-[#023E42]">{{ capacity }}</span>
            <button type="button" class="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-lg text-white" (click)="step('capacity', 1)">+</button>
          </div>
        </div>
        <div class="mt-4 rounded-lg bg-[#F8FCF9] p-3">
          <span class="text-sm text-[#6B7472]">{{ 'garden.beds.create.preview' | translate }}</span>
          <div class="mt-2 flex flex-wrap gap-2">
            @for (c of previewCells; track $index) {
              <div class="flex h-12 w-12 items-center justify-center rounded-lg border border-dashed border-gray-300 text-gray-300">+</div>
            }
          </div>
          <p class="mt-2 text-xs text-[#9BA6A1]">{{ 'garden.beds.create.pot-preview-hint' | translate }}</p>
        </div>
      }
    </div>

    <!-- Caractéristiques (facultatif) -->
    <div class="rounded-xl bg-white p-4">
      <h2 class="mb-3 text-base font-semibold text-[#023E42]">
        {{ 'garden.beds.create.characteristics' | translate }} <span class="text-xs font-normal text-[#9BA6A1]">({{ 'garden.beds.create.optional' | translate }})</span>
      </h2>

      <p class="mb-2 text-sm text-[#9BA6A1]">{{ 'garden.beds.create.exposure' | translate }}</p>
      <div class="mb-4">
        <vw-choice-selector [options]="exposurePills" [(value)]="exposure" variant="chips" [deselectable]="true"></vw-choice-selector>
      </div>

      <p class="mb-2 text-sm text-[#9BA6A1]">{{ 'garden.beds.create.orientation' | translate }}</p>
      <div class="mb-4">
        <vw-choice-selector [options]="orientationPills" [(value)]="orientation" variant="chips" [deselectable]="true"></vw-choice-selector>
      </div>

      @if (isRectangular) {
        <p class="mb-2 text-sm text-[#9BA6A1]">{{ 'garden.beds.create.soil' | translate }}</p>
        <vw-choice-selector [options]="soilPills" [(value)]="soilType" variant="chips" [deselectable]="true"></vw-choice-selector>
      }
    </div>

    <p class="text-center text-xs text-[#9BA6A1]">{{ 'garden.beds.create.editable-later' | translate }}</p>
  </div>

  <!-- Submit -->
  <div class="fixed bottom-0 left-0 right-0 flex gap-3 bg-white p-4 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]">
    <button type="button" class="flex-1 rounded-full border border-primary-500 py-3 font-medium text-primary-600" (click)="back()">
      {{ 'common.cancel' | translate }}
    </button>
    <vw-button class="flex-1" [label]="isRectangular ? 'garden.beds.create.submit' : 'garden.beds.create.submit-pot'" [look]="'primary'" [loading]="submitLoading" [disabled]="!canSubmit" (onClick)="submit()"></vw-button>
  </div>
</div>
